import React, { Component } from "react";
import "./TechCareerComponent.css";
import { Fade } from "react-reveal";
import { bootcampVsDegree } from "../../../portfolio";
import SoftwareSkill from "../../../components/softwareSkills/SoftwareSkill";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import TopButton from "../../../components/topButton/TopButton";
import OnlineTest from "./svg/OnlineTest";
import StudyBook from "./svg/StudyBooK";

class BootcampVsDegree extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="tech-main" id="skills">
        <Header theme={theme} />
        <div className="skills-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="skills-header" style={{ color: theme.text }}>
              From Bootcamp to Bachelor's
            </h1>
          </Fade>
          <Fade left duration={2000}>
            <div className="centered-hero">
              <OnlineTest />
              <StudyBook />
            </div>
          </Fade>
        </div>
        <div>
          {bootcampVsDegree.data.map((skill, i) => {
            return (
              <div key={i} className="skills-main-div">
                <div className="skills-text-div">
                  <Fade right duration={1000}>
                    <h1
                      className="skills-heading"
                      style={{ color: theme.text }}
                    >
                      {skill.title}
                    </h1>
                  </Fade>
                  <Fade left duration={1500}>
                    {Array.isArray(skill.softwareSkills) && (
                      <SoftwareSkill logos={skill.softwareSkills} />
                    )}
                  </Fade>
                  <Fade right duration={2000}>
                    <div>
                      <p
                        //key={i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skill.description}
                      </p>
                    </div>
                  </Fade>
                  <Fade left duration={2000}>
                    <div>
                      <h2
                        className="skills-heading"
                        style={{ color: theme.text }}
                      >
                        {skill.subTitle}
                      </h2>
                      {skill.skills?.map((skillSentence, i) => {
                        return (
                          <p
                            key={i}
                            className="subTitle skills-text"
                            style={{ color: theme.secondaryText }}
                          >
                            {skillSentence}
                          </p>
                        );
                      })}
                    </div>
                    <div>
                      {skill.paragrapghs.map((skillSentence, i) => {
                        return (
                          <p
                            key={i}
                            className="subTitle skills-text"
                            style={{ color: theme.secondaryText }}
                          >
                            {skillSentence}
                          </p>
                        );
                      })}
                    </div>
                  </Fade>
                  <Fade right duration={2000}>
                    <div>
                      <h3
                        className="skills-heading"
                        style={{ color: theme.text }}
                      >
                        {skill.subHeading}
                      </h3>
                    </div>
                    <div>
                      <p
                        key={i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skill.realityDescription}
                      </p>
                      {skill.listReality && (
                        <ul>
                          {skill.listReality.map((item, index) => (
                            <li
                              key={index}
                              className="subTitle skills-text"
                              style={{ color: theme.secondaryText }}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                      <p
                        key={i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skill.endRealityParagraph}
                      </p>
                    </div>
                  </Fade>
                  <Fade left duration={2000}>
                    <div>
                      <h3
                        className="skills-heading"
                        style={{ color: theme.text }}
                      >
                        {skill.degreeTitle}
                      </h3>
                      <p
                        key={i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skill.degreeDescription}
                      </p>
                      {skill.educationBenefits?.map((benefit, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                          <h2 style={{ color: theme.text }}>{benefit.title}</h2>
                          <p style={{ color: theme.secondaryText }}>
                            {benefit.description}
                          </p>

                          {benefit.list.length > 0 && (
                            <ul>
                              {benefit.list.map((item, i) => (
                                <li
                                  key={i}
                                  style={{ color: theme.secondaryText }}
                                >
                                  {item}
                                </li>
                              ))}
                            </ul>
                          )}

                          {benefit.subListDescription && (
                            <>
                              <p style={{ color: theme.secondaryText }}>
                                {benefit.subListDescription}
                              </p>
                              <ul>
                                {benefit.subList.map((subItem, i) => (
                                  <li
                                    key={i}
                                    style={{ color: theme.secondaryText }}
                                  >
                                    {subItem}
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                          <p style={{ color: theme.secondaryText }}>
                            {benefit.endListDescription}
                          </p>
                        </div>
                      ))}
                    </div>
                  </Fade>
                  <Fade right duration={2000}>
                    <div>
                      {skill.balancing?.map((benefit, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                          <h2 style={{ color: theme.text }}>{benefit.title}</h2>
                          <p style={{ color: theme.secondaryText }}>
                            {benefit.description}
                          </p>

                          {benefit.list.length > 0 && (
                            <ul>
                              {benefit.list.map((item, i) => (
                                <li
                                  key={i}
                                  style={{ color: theme.secondaryText }}
                                >
                                  {item}
                                </li>
                              ))}
                            </ul>
                          )}

                          {benefit.subListDescription && (
                            <>
                              <p style={{ color: theme.secondaryText }}>
                                {benefit.subListDescription}
                              </p>
                              <ul>
                                {benefit.subList.map((subItem, i) => (
                                  <li
                                    key={i}
                                    style={{ color: theme.secondaryText }}
                                  >
                                    {subItem}
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                          <p style={{ color: theme.secondaryText }}>
                            {benefit.endListDescription}
                          </p>
                        </div>
                      ))}
                    </div>
                  </Fade>
                  <Fade left duration={2000}>
                    <div>
                      <h3
                        className="skills-heading"
                        style={{ color: theme.text }}
                      >
                        {skill.finalThoughtsTitle}
                      </h3>
                      {skill.finalThoughtsParagrapghs?.map(
                        (skillSentence, i) => {
                          return (
                            <p
                              key={i}
                              className="subTitle skills-text"
                              style={{ color: theme.secondaryText }}
                            >
                              {skillSentence}
                            </p>
                          );
                        }
                      )}
                    </div>
                    <div>
                      {skill.stacks?.map((stack, index) => (
                        <div key={index} className="stack-container">
                          <h3 className="stack-title">{stack.name}</h3>
                          <p className="stack-description">
                            {stack.description}
                          </p>
                          <div className="software-skills-main-div">
                            <ul className="dev-icons">
                              {stack.logos.map((logo, i) => (
                                <li
                                  className="software-skill-inline"
                                  name={logo.name}
                                >
                                  <span
                                    className="iconify"
                                    data-icon={logo.className}
                                    data-inline="false"
                                  ></span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Fade>
                </div>
              </div>
            );
          })}
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default BootcampVsDegree;
